<i18n>
{
  "no": {
    "header": "Beklager, noe gikk galt under oppsett av enheten.",
    "infoMessage": "Det oppstod en feil og enheten din er ikke tilkoblet ennå. Du kan lukke dette vinduet og prøve igjen!"
  },
  "en": {
    "header": "Sorry, something went wrong when setting up your device.",
    "infoMessage": "An error occured and your device is not yet connected. You may close this window and try again!"
  }
}
</i18n>

<template>
  <div class="page">
    <FormWrapper>
      <div class="text-center">
        <img :src="failureImage" alt="" aria-hidden="true" class="margin-top-3xl result-image" />

        <!-- Was a native <header size="l">, which rendered unstyled. -->
        <TnHeading type="h1" size="s" align="center" class="margin-vertical-2xl">
          {{ t('header') }}
        </TnHeading>

        <TnParagraph size="s">{{ t('infoMessage') }}</TnParagraph>
      </div>
    </FormWrapper>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { TnHeading, TnParagraph } from '@telenornorgeinternal/telegrafen-vue3-core';

import FormWrapper from '@/components/FormWrapper.vue';
import failureImage from '@/assets/device_failure.svg';

const { t } = useI18n();
</script>

<style scoped>
.result-image {
  display: block;
  width: 100px;
  height: 100px;
  margin-inline: auto;
}
</style>
